import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEye } from '@fortawesome/free-solid-svg-icons';
import "./NotificacaoItem.css";

const NotificationItem = ({ title, description, notificacaoLida, componentAction, onMarkAsRead }) => {
  return (
    <div className={`notification-item ${notificacaoLida ? "read" : ""} p-3 border-bottom d-flex justify-content-between align-items-center`}>
      {/* Conteúdo da Notificação */}
      <div className="notification-content">
        <h6 className="mb-1 notification-title">{title}</h6>
        <p className="text-muted mb-0">{description}</p>
      </div>

      {/* Ações */}
      <div className="notification-actions align-items-end">

        {componentAction}
        <button
          className="btn btn-sm btn-outline-secondary mb-2 ml-2"
          style={{ fontSize: "smaller" }}
          onClick={onMarkAsRead}
          disabled={notificacaoLida}
        >
          {notificacaoLida ? <FontAwesomeIcon icon={faCheck} /> : <FontAwesomeIcon icon={faEye} />}
        </button>
      </div>
    </div>
  );
};

export default NotificationItem;
